module.exports = __webpack_public_path__ + "img/c01_unittechprodromoschampion_Normal_ua.f017884c.webp";